import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-0 me-md-auto link-dark text-decoration-none text-nowrap" }
const _hoisted_2 = {
  key: 0,
  class: "fs-5"
}
const _hoisted_3 = {
  key: 1,
  class: "fs-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "divider-sidebar" }, null, -1)
const _hoisted_7 = { class: "nav nav-pills flex-column mb-auto" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "row col-md-12 d-flex" }
const _hoisted_10 = { class: "row col-md-12 d-flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "divider-sidebar" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "collapsible-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar col-md-3", {'sidebar-icon-only': (_ctx.iconOnly && !_ctx.collapsible) || (_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed), 'sidebar-collapsed': (!_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed)}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column p-3", {'d-none': (!_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed)}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (((_ctx.collapsible && !_ctx.isCollapsed) || (!_ctx.iconOnly && !_ctx.collapsible)))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
      ]),
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item nav-item-sidebar",
            key: module.name
          }, [
            (module.target === '_blank')
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: module.href,
                  target: "_blank",
                  class: _normalizeClass(["nav-link link-dark d-flex align-items-center", {'active p-button p-button-raised': module.isActive}]),
                  "aria-current": "page"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-md-2", {'active': module.isActive}])
                    }, [
                      _createVNode(_component_FontAwesomeIcon, {
                        icon: ['fas', module.icon],
                        size: "sm",
                        width: "18px"
                      }, null, 8, ["icon"])
                    ], 2),
                    (((_ctx.collapsible && !_ctx.isCollapsed) || (!_ctx.iconOnly && !_ctx.collapsible)))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["col-md-2 text-nowrap", {'active': module.isActive}])
                        }, _toDisplayString(module.name), 3))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_8)), [
                  [
                    _directive_tooltip,
                    {value: ((_ctx.iconOnly && !_ctx.collapsible) || (_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed) ? module.name : ''), class: ((_ctx.iconOnly && !_ctx.collapsible) || (_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed) ? 'p-tooltip-sidebar' : 'p-tooltip-none')},
                    void 0,
                    { right: true }
                  ]
                ])
              : _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: module.href,
                  class: _normalizeClass(["nav-link link-dark d-flex align-items-center", {'active p-button p-button-raised': module.isActive}]),
                  "aria-current": "page",
                  onClick: _ctx.resetCache
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-md-2", {'active': module.isActive}])
                      }, [
                        _createVNode(_component_FontAwesomeIcon, {
                          icon: ['fas', module.icon],
                          size: "sm",
                          width: "18px"
                        }, null, 8, ["icon"])
                      ], 2),
                      (((_ctx.collapsible && !_ctx.isCollapsed) || (!_ctx.iconOnly && !_ctx.collapsible)))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["col-md-2 text-nowrap", {'active': module.isActive}])
                          }, _toDisplayString(module.name), 3))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to", "class", "onClick"])), [
                  [
                    _directive_tooltip,
                    {value: ((_ctx.iconOnly && !_ctx.collapsible) || (_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed) ? module.name : ''), class: ((_ctx.iconOnly && !_ctx.collapsible) || (_ctx.iconOnly && _ctx.collapsible && _ctx.isCollapsed) ? 'p-tooltip-sidebar' : 'p-tooltip-none')},
                    void 0,
                    { right: true }
                  ]
                ])
          ]))
        }), 128))
      ]),
      _hoisted_11
    ], 2),
    (_ctx.collapsible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Button, {
            icon: (_ctx.isCollapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-left'),
            class: "p-button-rounded p-button-secondary p-button-rounded-collapsible",
            onClick: _ctx.toggleCollapse
          }, null, 8, ["icon", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}